//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

export enum UniversalItemType {
  // Social Network item types
  Pinterest = 'pinterest',
  Facebook = 'facebook',
  Instagram = 'instagram',
  TikTok = 'tiktok',
  Twitter = 'twitter',
  Tumblr = 'tumblr',
  Snapchat = 'snapchat',
  YouTube = 'youtube',

  // Curalate-related item types
  Like2Buy = 'like2buy',
  SchedulerPinterest = 'scheduler-pinterest',
  SchedulerInstagram = 'scheduler-instagram',
  Syndication = 'syndication',
  SavedImage = 'saved-image',
  Fanreel = 'fanreel',
  Reveal = 'reveal',
  Bookmarklet = 'bookmarklet',
  MediaImport = 'media-import',
  Product = 'product',

  // Bazaarvoice
  Bazaarvoice = 'bazaarvoice',

  // Misc. item types
  Desktop = 'desktop',
  Mobile = 'mobile',
}

export function getUniversalItemType(
  universalItemType: string,
): UniversalItemType {
  return universalItemType as UniversalItemType;
}
